import { Paths } from '@/pages/routers';

export const dataHeaderMenu = [
  { id: 'about', title: 'About', link: Paths.About, activePaths: [Paths.About] },
  { id: 'services', title: 'Services', link: `${Paths.Book}?index=1`, activePaths: [] },
  { id: 'contact', title: 'Contact', link: Paths.Contact, activePaths: [Paths.Contact] },
  { id: 'book', title: 'Book', link: Paths.Book, activePaths: [Paths.Home] },
];
